import React, { useEffect } from "react";
import { setCurrentWizardData } from "../../../../redux/actions/wizardActions";
import { createCredObject } from "../../../../common/factory/credential.factory";
import { useDispatch, useSelector } from "react-redux";
import { CredentialsType } from "../../../../common/interfaces/credentials/Credentials";
import { saveCred } from "../../../../redux/actions/credActions";
import { clone } from "../../../../common/utils/helper";
import Spinner from "@atlaskit/spinner";
import StatusSuccessIcon from "@atlaskit/icon/core/status-success";

/**
 * Saves custom header authentication details.
 * @param {string} credName - The name of the credential to be saved, only applicable for new credentials.
 * @param {string} credRefProperty - The reference property of the credential id, this is where we put the credential id in the currentData, such as currentData.myCredRef = theId
 * @param {string} authRadioButtonProperty - The property in currentData where you added the radio button option if creating new or using exiting.
 * @param {string} authRadioButtonValue - The value which indicates a new credential shall be created. E.g. the value of the cred radio btn
 * @param {string} value - The value to be saved, if new it will be a list of headers [key,value], if existing it will be the credential id
 * @returns {void} - Returns nothing.
 */
const SaveCustomHeaderAuth = ({ credName, credRefProperty, authRadioButtonProperty, createNewAuthRadioBtnValue, value }) => {
  const dispatch = useDispatch();
  const currentData = useSelector((state) => state.wizard.currentData);

  const saveNewAuth = async () => {
    //run add basic auth
    const authObj = createCredObject(credName, CredentialsType.CUSTOM_HEADER);
    authObj.data.headers = value;
    const basicPromise = dispatch(saveCred(authObj));
    Promise.all([basicPromise])
      .then((results) => {
        if (!currentData.importCredentialsReferences) {
          currentData.importCredentialsReferences = {}; // Initialize importCredentialsReferences as an empty object
        }

        currentData.importCredentialsReferences[credRefProperty] = results[0]?.id;

        dispatch(setCurrentWizardData(clone(currentData)));
      })
      .catch((error) => {
        console.error("Error saving credentials:", error);
      });
  };
  /**
   * We set this ref to have the same expirence when using the credential regardless of created new or choosing existing.
   */
  const addCredentialReference = () => {
    if (!currentData.importCredentialsReferences) {
      currentData.importCredentialsReferences = {}; // Initialize importCredentialsReferences as an empty object
    }
    currentData.importCredentialsReferences[credRefProperty] = value;
    dispatch(setCurrentWizardData(clone(currentData)));
  };
  const isSaved = () => {
    if (currentData && currentData.importCredentialsReferences && currentData.importCredentialsReferences[credRefProperty]) {
      return true;
    }
    return false;
  };

  useEffect(() => {
    //recursive blocker
    if (!isSaved() && currentData[authRadioButtonProperty] && createNewAuthRadioBtnValue) {
      if (currentData[authRadioButtonProperty] === createNewAuthRadioBtnValue) {
        saveNewAuth();
      } else {
        addCredentialReference();
      }
    }
  }, [currentData]);
  return (
    <>
      {!isSaved() && (
        <>
          Saving Okta token...
          <Spinner />
        </>
      )}
      {isSaved() && (
        <>
          <StatusSuccessIcon label="" color="#00875a" />
          Okta Token Saved
        </>
      )}
    </>
  );
};

export default SaveCustomHeaderAuth;
